import React from 'react';
import PropTypes from 'prop-types';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {largishAndUp} from '~libSass/base/_exports.sass';

export const ResultsCount = (props) => {
  const {matches: largeScreens} = useMatchQuery(`(min-width: ${largishAndUp})`);
  const resultsCount = props.numTemplates;

  if (largeScreens && !props.seoHeader)
    return <span data-qa-id="gallery__results-count">({resultsCount})</span>;

  return (
    <span className="gallery__results-count" data-qa-id="gallery__results-count">
      {resultsCount} items
    </span>
  );
};

ResultsCount.propTypes = {
  numTemplates: PropTypes.number.isRequired,
};
